// extracted by mini-css-extract-plugin
export default {"title":"Account_title__9WZVG","subtitle":"Account_subtitle__sZgkN","summary":"Account_summary__-I03Z","rule":"Account_rule__1qua0"};